import { createConfig, http } from 'wagmi';
import { injected } from '@wagmi/core';
import { bsc } from 'viem/chains';

export const BSC_CHAIN_ID = bsc.id;

export const wagmiConfig = createConfig({
  chains: [bsc],
  connectors: [injected({ shimDisconnect: true })],
  transports: {
    [bsc.id]: http(),
  },
});
